if (!window.customElements.get("component-quick-add-to-bag")) {
  class ComponentQuickAddToBag extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener("click", this._onClick);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this._onClick);
    }

    _onClick(event) {
      const trigger = event.target.closest("[data-action='add-to-cart']");
      if (!trigger) return;

      const variantId = Number(this.dataset.variantId);
      if (!variantId) return;

      event.preventDefault();

      window.enrouteCart?.addToCart?.({
        id: variantId,
        quantity: 1,
        productId: Number(this.dataset.productId) || null,
        handle: this.dataset.productHandle || "",
        title: this.dataset.productTitle || "",
        image: this.dataset.productImage || "",
        variantText: this.dataset.variantText || "",
        url: trigger.href || "",
      });
    }
  }

  window.customElements.define("component-quick-add-to-bag", ComponentQuickAddToBag);
}
